<template lang="pug">
div
	.mt-2(v-if="resultados && resultados.clientes.length > 0")
		.card
			.card-header
				| Resultados
				download-excel(
					class   = "btn btn-warning btn-sm ml-2"
					:data   = "json_data"
					:fields = "json_fields"
					:meta   = "json_meta"
					name	= "informe.xls"
				)
					span.fa.fa-download.mr-2
					| XLS
			.table
				table.table.table-striped.table-condensed.text-right
					thead
						tr.bg-dark.text-white
							th(@click="ordenar('nombre', 'nombre')", rowspan="2", style="vertical-align:top;")
								| Cliente
								span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'nombre'")
							th(
								v-for="campo in resultados.campos"
								:key="campo.campo"
								@click="ordenar('campo', campo.campo)"
								:colspan="anos.length"
								class="text-center"
							)
								| {{campo.nombre}}
								span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'campo' && orden.campo === campo.campo")
							template(v-if="resultados.clientes[0].soportes && resultados.clientes[0].soportes.length > 0")
								th(
									v-for="(soporte, i) in resultados.clientes[0].soportes"
									:key="soporte.ID_soporte"
									@click="ordenar('soporte', i)"
									:colspan="anos.length"
									class="text-center"
								)
									| {{soporte.nombre}}
									span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'soporte' && orden.campo === i")
							template(v-if="resultados.clientes[0].eventos")
								th(
									@click="ordenar('eventos', 'eventos')"
									:colspan="anos.length"
									class="text-center"
								)
									| Eventos
								span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'eventos'")
							template(v-if="resultados.clientes[0].partidas && resultados.clientes[0].partidas.length > 0")
								th(
									v-for="(partida, i) in resultados.clientes[0].partidas"
									:key="partida.ID"
									@click="ordenar('partida', i)"
									:colspan="anos.length"
									class="text-center"
								)
									| {{partida.nombre}}
									span.fa.ml-2(:class="(orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'" v-if="orden.tipo === 'partida' && orden.campo === i")
						tr.bg-light
							template(
								v-for="campo in resultados.campos"
							)
								th(
									v-for="ano in anos"
									:key="campo.campo + '-' + ano"
								)
									| {{ ano }}
							
							template(
								v-for="soporte in resultados.clientes[0].soportes"
							)
								th(
									v-for="ano in anos"
									:key="soporte.ID_soporte + '-' + ano"
									style="text-align:center;"
								) {{ ano }}
							
							template(
								v-if="resultados.clientes[0].eventos"
							)
								th(
									v-for="ano in anos"
									:key="'eventos-' + ano"
								) {{ ano }}
							
							template(
								v-if="resultados.clientes[0].partidas"
								v-for="partida in resultados.clientes[0].partidas"
							)
								th(
									v-for="ano in anos"
									:key="partida.nombre + '-' + ano"
								) {{ ano }}
				
					tbody
						tr(v-for="cliente in resultadosClientes" :key="cliente.ID_cliente")
							td
								| {{cliente.nombre}}
							template(v-for="(campo, id) in cliente.campos")
								td.importe(
									v-for="(ano, a) in campo.anos"
									:key="campo.nombre + 'res-' + a"
									@click="verDetalles(cliente.nombre, campo.anos, campo.nombre)"
									:style="a === campo.anos.length - 1 ? {borderRight: '1px solid #aaaaaa'} : {}"
								)
									| {{ano.importe | currency('')}}
									span(v-if="id === 'cobertura'") %
									span(v-if="id !== 'cobertura'") €
							template(v-if="cliente.soportes" v-for="soporte in cliente.soportes")
								td.importe(
									v-for="(ano, a) in soporte.anos"
									:key="soporte.ID_soporte + 'res-' + a"
									@click="verDetallesSoporte(cliente.nombre, soporte.anos, 'Soporte: ' + soporte.nombre)"
									:style="a === soporte.anos.length - 1 ? {borderRight: '1px solid #aaaaaa'} : {}"
								)
									| {{ano.importe | currency('')}} €
							template(v-if="cliente.eventos")
								td.importe(
									v-for="(ano, a) in cliente.eventos.anos"
									:key="'eventosres-' + a"
									@click="verDetalles(cliente.nombre, cliente.eventos.anos, 'Eventos')"
									:style="a === cliente.eventos.anos.length - 1 ? {borderRight: '1px solid #aaaaaa'} : {}"
								)
									| {{ano.importe | currency('')}} €

							template(v-if="cliente.partidas" v-for="partida in cliente.partidas")
								td.importe(
									v-for="(ano, a) in partida.anos"
									:key="'partidas' + partida.ID_partida + '-' + a"
									@click="verDetalles(cliente.nombre, partida.anos, 'Partida: ' + partida.nombre)"
									:style="a === partida.anos.length - 1 ? {borderRight: '1px solid #aaaaaa'} : {}"
								)
									| {{ano.importe | currency('')}} €
	detalles-meses(
		v-if="detalles"
		:anos="detalles.anos"
		:cliente="detalles.cliente"
		:tipo="detalles.tipo"
		@cerrar="detalles = null"
	)
</template>

<script>
import DetallesMeses from './verDetallesComparados'
export default {
	props: ['resultados'],
	components: {
		DetallesMeses
	},
	data () {
		return {
			detalles: null,
			orden: {
				tipo: 'nombre',
				campo: 'nombre',
				sentido: 1
			}
		}
	},
	computed: {
		anos () {
			const mapa = this.resultados.clientes.reduce((anos, resul) => {
				if (resul.campos && typeof resul.campos === 'object') {
					for (let campo in resul.campos) {
						for (let mes in resul.campos[campo].meses) {
							const ano = new Date(parseInt(mes)).getFullYear()
							if (!anos.has(ano)) {
								anos.set(ano, ano)
							}
						}
					}
				} else if (resul.eventos && resul.eventos.meses) {
					for (let mes in resul.eventos.meses) {
						const ano = new Date(parseInt(mes)).getFullYear()
						if (!anos.has(ano)) {
							anos.set(ano, ano)
						}
					}
				} else if (resul.partidas && Array.isArray(resul.partidas)) {
					for (let i = 0; i < resul.partidas.length; i++) {
						anos = resul.partidas[i].meses.reduce((datos, mes) => {
							const ano = new Date(parseInt(mes)).getFullYear()
							if (!anos.has(ano)) {
								anos.set(ano, ano)
							}
						}, anos)
					}
				}
				return anos
			}, new Map())
			return Array.from(mapa).map(a => a[0]).sort()
		},
		resultadosClientes () {
			if (!this.resultados) {
				return []
			}
			if (this.orden.campo) {
				const clientes = [].concat(this.resultados.clientes).sort((a, b) => {
					if (this.orden.tipo === 'campo') {
						if (a.campos[this.orden.campo].importe > b.campos[this.orden.campo].importe) {
							return this.orden.sentido
						} else if (a.campos[this.orden.campo].importe < b.campos[this.orden.campo].importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'soporte') {
						if (a.soportes[this.orden.campo].total.real > b.soportes[this.orden.campo].total.real) {
							return this.orden.sentido
						} else if (a.soportes[this.orden.campo].total.real < b.soportes[this.orden.campo].total.real) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'eventos') {
						if (a.eventos.importe > b.eventos.importe) {
							return this.orden.sentido
						} else if (a.eventos.importe < b.eventos.importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'nombre') {
						if (a.nombre > b.nombre) {
							return this.orden.sentido
						} else if (a.nombre < b.nombre) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					} else if (this.orden.tipo === 'partida') {
						if (a.partidas[this.orden.campo].importe > b.partidas[this.orden.campo].importe) {
							return this.orden.sentido
						} else if (a.partidas[this.orden.campo].importe < b.partidas[this.orden.campo].importe) {
							return this.orden.sentido * -1
						} else {
							return 0
						}
					}
				})

				// Ahora tenemos que separar por los años
				return clientes.reduce((ant, cliente) => {
					if (cliente.campos) {
						for (let campo in cliente.campos) {
							cliente.campos[campo].anos = this.anos.reduce((acum, ano) => {
								const anoActual = {importe: 0, importes: [], ano: ano, meses: new Array(12).fill(0, 0)}
								for (let mes in cliente.campos[campo].meses) {
									const importe = parseFloat(cliente.campos[campo].meses[mes].importe)
									const fecha = new Date(parseInt(mes))
									if (fecha.getFullYear() === ano) {
										if (!isNaN(importe)) {
											anoActual.importes.push(importe)
											anoActual.importe = anoActual.importe + importe
											anoActual.meses[fecha.getMonth()] += importe
										}
									}
								}
								acum.push(anoActual)
								return acum
							}, []).sort((a, b) => {
								if (a.ano > b.ano) {
									return 1
								} else {
									return -1
								}
							})
						}
					}
					if (cliente.soportes && cliente.soportes.length > 0) {
						cliente.soportes = cliente.soportes.reduce((acum, soporte) => {
							soporte.anos = this.anos.reduce((anos, ano) => {
								const anoActual = {importe: 0, importes: [], ano: ano, meses: new Array(12).fill(0, 0)}
								for (let m in soporte.meses) {
									const mes = soporte.meses[m]
									const fecha = new Date(parseInt(mes.mes))
									if (ano === fecha.getFullYear()) {
										const importe = mes.real
										anoActual.importe = anoActual.importe + importe
										anoActual.importes.push(importe)
										anoActual.meses[fecha.getMonth()] += importe
									}
								}
								anos.push(anoActual)
								return anos
							}, []).sort((a, b) => {
								if (a.ano > b.ano) {
									return 1
								} else {
									return -1
								}
							})
							acum.push(soporte)
							return acum
						}, [])
					}

					if (cliente.eventos) {
						cliente.eventos.anos = this.anos.reduce((anos, ano) => {
							const anoActual = {importe: 0, importes: [], ano: ano, meses: new Array(12).fill(0, 0)}
							for (let m in cliente.eventos.meses) {
								const importe = cliente.eventos.meses[m].importe
								const fecha = new Date(parseInt(m))
								if (ano === fecha.getFullYear()) {
									anoActual.importe = anoActual.importe + importe
									anoActual.importes.push(importe)
									anoActual.meses[fecha.getMonth()] += importe
								}
							}
							anos.push(anoActual)
							return anos
						}, []).sort((a, b) => {
							if (a.ano > b.ano) {
								return 1
							} else {
								return -1
							}
						})
					}

					if (cliente.partidas && cliente.partidas.length > 0) {
						cliente.partidas = cliente.partidas.reduce((acum, partida) => {
							partida.anos = this.anos.reduce((anos, ano) => {
								const anoActual = {importe: 0, importes: [], ano: ano, meses: new Array(12).fill(0, 0)}
								for (let m in partida.meses) {
									const importe = partida.meses[m].importe
									const fecha = new Date(parseInt(m))
									if (ano === fecha.getFullYear()) {
										anoActual.importe = anoActual.importe + importe
										anoActual.importes.push(importe)
										anoActual.meses[fecha.getMonth()] += importe
									}
								}
								anos.push(anoActual)
								return anos
							}, []).sort((a, b) => {
								if (a.ano > b.ano) {
									return 1
								} else {
									return -1
								}
							})
							acum.push(partida)
							return acum
						}, [])
					}

					ant.push(cliente)
					return ant
				}, [])
			} else {
				return this.resultados.clientes
			}
		},
		json_data () {
			if (!this.resultadosClientes) {
				return []
			}

			const arr = []

			for (let i = 0; i < this.resultadosClientes.length; i++) {
				const cliente = this.resultadosClientes[i]
				const obj = {}
				obj.cliente = cliente.nombre

				if (cliente.campos) {
					for (let k in cliente.campos) {
						for (let a in cliente.campos[k].anos) {
							const ano = cliente.campos[k].anos[a]
							obj[k + ' ' + ano.ano] = ano.importe.toString().replace('.', ',')
						}
					}
				}

				if (cliente.soportes) {
					for (let k in cliente.soportes) {
						for (let a in cliente.soportes[k].anos) {
							const ano = cliente.soportes[k].anos[a]
							obj[cliente.soportes[k].nombre + ' ' + ano.ano] = ano.importe.toString().replace('.', ',')
						}
					}
				}

				if (cliente.eventos) {
					for (let a in cliente.eventos.anos) {
						const ano = cliente.eventos.anos[a]
						obj['eventos ' + ano.ano] = ano.importe.toString().replace('.', ',')
					}
				}

				if (cliente.partidas) {
					for (let k in cliente.partidas) {
						for (let a in cliente.partidas[k].anos) {
							const ano = cliente.partidas[k].anos[a]
							obj[cliente.partidas[k].nombre + ' ' + ano.ano] = ano.importe.toString().replace('.', ',')
						}
					}
				}

				arr.push(obj)
			}

			return arr
		},
		json_fields () {
			if (!this.resultados) {
				return {}
			}
			const f = {}

			const cliente = this.resultadosClientes[0]

			f.cliente = 'Number'
			for (let k in cliente.campos) {
				for (let a in cliente.campos[k].anos) {
					const ano = cliente.campos[k].anos[a]
					f[k + ' ' + ano.ano] = 'Number'
				}
			}

			for (let k in cliente.soportes) {
				const nombre = cliente.soportes[k].nombre
				for (let a in cliente.soportes[k].anos) {
					const ano = cliente.soportes[k].anos[a]
					f[nombre + ' ' + ano.ano] = 'Number'
				}
			}

			if (cliente.eventos) {
				for (let a in cliente.eventos.anos) {
					const ano = cliente.eventos.anos[a]
					f['eventos ' + ano.ano] = 'Number'
				}
			}

			for (let k in cliente.partidas) {
				const nombre = cliente.partidas[k].nombre
				for (let a in cliente.partidas[k].anos) {
					const ano = cliente.partidas[k].anos[a]
					f[nombre + ' ' + ano.ano] = 'Number'
				}
			}
			return f
		},
		json_meta () {
			return [
				[{
					'key': 'charset',
					'value': 'utf-8'
				}]
			]
		}
	},
	methods: {
		ordenar (tipo, campo) {
			this.orden.tipo = tipo
			if (this.orden.campo === campo) {
				this.orden.sentido = this.orden.sentido * -1
			} else {
				this.orden.campo = campo
				this.orden.sentido = 1
			}
		},
		verDetalles (cliente, anos, tipo) {
			this.detalles = {
				cliente: cliente,
				anos: anos,
				tipo: tipo,
				fechas: this.resultados.fechas
			}
		},

		verDetallesSoporte (cliente, anos, tipo) {
			this.verDetalles(cliente, anos, tipo)
			// const m = {}

			// for (let i = 0; i < meses.length; i++) {
			// 	m[meses[i].mes] = {importe: meses[i].real}
			// }

			// this.verDetalles(cliente, m, tipo)
		}
	}
}
</script>

<style scoped>
td.importe:hover {
	cursor: pointer;
}

td.importe:hover {
	background-color: darkred;
	color: white;
}
</style>


// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porClientes/tablaComparativa.vue